import { render } from "./LiveTransmissions.vue?vue&type=template&id=1b2007fc&scoped=true"
import script from "./LiveTransmissions.vue?vue&type=script&lang=js"
export * from "./LiveTransmissions.vue?vue&type=script&lang=js"

import "./LiveTransmissions.vue?vue&type=style&index=0&id=1b2007fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2007fc"]])

export default __exports__